import { HStack, Icon, Text } from '@chakra-ui/react'
import { faTag } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import type { PolicyVersionAdjustment } from '@/dtos/exceptionalDiscount'
import { AdjustmentKind, AdjustmentType } from '@/dtos/exceptionalDiscount'
import { fmtKc, fmtPctChip } from '../lib/premiumMath'

const valueTextOf = (adjustment: PolicyVersionAdjustment) => {
  switch (adjustment.type) {
    case AdjustmentType.percentage: return `− ${fmtPctChip(adjustment.value).replace('%', ' %')}`
    case AdjustmentType.absolute: return `− ${fmtKc(adjustment.value)}`
    default: return fmtKc(adjustment.value)
  }
}

export const AdjustmentChip = ({ adjustment }: { adjustment: PolicyVersionAdjustment }) => {
  const isDiscount = adjustment.kind === AdjustmentKind.exceptionalDiscount
  const label = isDiscount ? 'Sleva' : 'Subvence'
  const title = adjustment.note ? `${label} ${valueTextOf(adjustment)} — ${adjustment.note}` : `${label} ${valueTextOf(adjustment)}`

  return (
    <HStack
      spacing={1}
      px={1.5}
      py={0.5}
      bg={isDiscount ? 'green.100' : 'primary.50'}
      color={isDiscount ? 'green.700' : 'primary.700'}
      borderRadius="full"
      title={title}
      w="fit-content"
    >
      <Icon as={FontAwesomeIcon} icon={faTag} boxSize={2.5} />
      <Text fontSize="2xs" fontWeight="bold" whiteSpace="nowrap" color="inherit">
        {label} {valueTextOf(adjustment)}
      </Text>
    </HStack>
  )
}
